/**
 * 字典转换工具
 * 用于将数据库中的字典值转换为中文显示标签
 */

// 分类字典映射
const categoryDict: Record<string, string> = {
  'patent_technology': '专利技术',
  'trademark_brand': '商标品牌',
  'copyright_works': '版权作品',
  'copyright_work': '版权作品',
  'patent_pool': '专利池',
  'patent_search': '专利检索',
  '专利技术': '专利技术',
  '商标品牌': '商标品牌',
  '版权作品': '版权作品',
  '专利池': '专利池',
  '专利检索': '专利检索',
};

// 行业字典映射
const industryDict: Record<string, string> = {
  'manufacturing': '制造业',
  'medical_health': '医疗健康',
  'tourism': '旅游业',
  'traditional_craft': '传统工艺',
  'new_energy_vehicle': '新能源汽车',
  'information_technology': '信息技术',
  '制造业': '制造业',
  '医疗健康': '医疗健康',
  '旅游业': '旅游业',
  '传统工艺': '传统工艺',
  '新能源汽车': '新能源汽车',
  '信息技术': '信息技术',
};

// 核心技术字典映射
const technologyDict: Record<string, string> = {
  'deep_learning': '深度学习',
  'medical_imaging': '医学影像',
  'artificial_intelligence': '人工智能',
  'iot': '物联网',
  'data_analysis': '数据分析',
  'industry_4_0': '工业4.0',
  // 新能源/电池等技术
  'battery_technology': '电池技术',
  'energy_storage': '能源存储',
  'brand_design': '品牌设计',
  'tourism_marketing': '旅游营销',
  'cultural_heritage': '文化传承',
  'patent_sharing': '专利共享',
  'big_data': '大数据',
  'intelligent_search': '智能检索',
  'intellectual_property': '知识产权',
  'new_energy_vehicle': '新能源汽车',
  'tourism': '旅游业',
  'traditional_craft': '传统工艺',
  '深度学习': '深度学习',
  '医学影像': '医学影像',
  '人工智能': '人工智能',
  '物联网': '物联网',
  '数据分析': '数据分析',
  '工业4.0': '工业4.0',
  '品牌设计': '品牌设计',
  '旅游营销': '旅游营销',
  '文化传承': '文化传承',
  '专利共享': '专利共享',
  '大数据': '大数据',
  '智能检索': '智能检索',
  '知识产权': '知识产权',
  '新能源汽车': '新能源汽车',
  '旅游业': '旅游业',
  '传统工艺': '传统工艺',
};

/**
 * 获取分类标签
 * @param categoryValue 分类值（字典值或中文）
 * @returns 中文分类标签
 */
export const getCategoryLabel = (categoryValue: string | undefined | null): string => {
  if (!categoryValue) return '未知';
  
  const value = String(categoryValue).trim();
  
  // 直接匹配
  if (categoryDict[value]) {
    return categoryDict[value];
  }
  
  // 忽略大小写匹配
  const lowerValue = value.toLowerCase();
  for (const [key, label] of Object.entries(categoryDict)) {
    if (key.toLowerCase() === lowerValue) {
      return label;
    }
  }
  
  // 包含匹配
  for (const [key, label] of Object.entries(categoryDict)) {
    if (lowerValue.includes(key.toLowerCase()) || key.toLowerCase().includes(lowerValue)) {
      return label;
    }
  }
  
  return value;
};

/**
 * 获取行业标签
 * @param industryValue 行业值（字典值或中文）
 * @returns 中文行业标签
 */
export const getIndustryLabel = (industryValue: string | undefined | null): string => {
  if (!industryValue) return '';
  
  const value = String(industryValue).trim();
  
  // 直接匹配
  if (industryDict[value]) {
    return industryDict[value];
  }
  
  // 忽略大小写匹配
  const lowerValue = value.toLowerCase();
  for (const [key, label] of Object.entries(industryDict)) {
    if (key.toLowerCase() === lowerValue) {
      return label;
    }
  }
  
  // 包含匹配
  for (const [key, label] of Object.entries(industryDict)) {
    if (lowerValue.includes(key.toLowerCase()) || key.toLowerCase().includes(lowerValue)) {
      return label;
    }
  }
  
  return value;
};

/**
 * 获取核心技术标签
 * @param technologyValue 技术值（字典值或中文）
 * @returns 中文技术标签
 */
export const getTechnologyLabel = (technologyValue: string | undefined | null): string => {
  if (!technologyValue) return '';
  
  const value = String(technologyValue).trim();
  
  // 直接匹配
  if (technologyDict[value]) {
    return technologyDict[value];
  }
  
  // 忽略大小写匹配
  const lowerValue = value.toLowerCase();
  for (const [key, label] of Object.entries(technologyDict)) {
    if (key.toLowerCase() === lowerValue) {
      return label;
    }
  }
  
  // 包含匹配
  for (const [key, label] of Object.entries(technologyDict)) {
    if (lowerValue.includes(key.toLowerCase()) || key.toLowerCase().includes(lowerValue)) {
      return label;
    }
  }
  
  return value;
};

/**
 * 批量转换核心技术数组
 * @param technologyValues 技术值数组（可能是字符串数组或逗号分隔的字符串）
 * @returns 中文技术标签数组
 */
export const getTechnologyLabels = (technologyValues: string | string[] | undefined | null): string[] => {
  if (!technologyValues) return [];
  
  let values: string[] = [];
  
  if (Array.isArray(technologyValues)) {
    values = technologyValues;
  } else if (typeof technologyValues === 'string') {
    // 尝试按逗号分隔
    values = technologyValues.split(',').map(v => v.trim()).filter(v => v);
  } else {
    return [];
  }
  
  return values.map(v => getTechnologyLabel(v)).filter(v => v);
};







